(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Mobile-Teacher_tab"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const tabs = document.querySelectorAll('.mobile-product-tabs__tab');
    if (tabs.length === 0) return;

    // Find the section element by finding the parent of the tabs
    const tabsContainer = tabs[0].closest('.mobile-product-tabs-section');
    if (!tabsContainer) return;

    // Enhanced sticky behavior - ensure tabs stay sticky when scrolling
    const headerHeight = 65; // Mobile teacher header height
    let initialTop = tabsContainer.getBoundingClientRect().top + window.scrollY;
    let isFixed = false;
    let placeholderElement = null;

    function updateStickyPosition() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const tabsRect = tabsContainer.getBoundingClientRect();

      // When scrolling down past the initial position
      if (scrollTop >= initialTop - headerHeight) {
        if (!isFixed) {
          // Create placeholder to prevent layout shift
          if (!placeholderElement) {
            placeholderElement = document.createElement('div');
            placeholderElement.style.height = tabsContainer.offsetHeight + 'px';
            placeholderElement.style.visibility = 'hidden';
            placeholderElement.className = 'tabs-placeholder';
            tabsContainer.parentNode.insertBefore(placeholderElement, tabsContainer);
          }

          // Use class-based approach to avoid flickering
          tabsContainer.classList.add('is-fixed');
          isFixed = true;
        }
      } else {
        // Reset to sticky when scrolling back up
        if (isFixed) {
          tabsContainer.classList.remove('is-fixed');

          // Remove placeholder
          if (placeholderElement && placeholderElement.parentNode) {
            placeholderElement.parentNode.removeChild(placeholderElement);
            placeholderElement = null;
          }

          isFixed = false;
        }
      }
    }

    // Initial check
    updateStickyPosition();

    // Throttle scroll events for better performance
    let ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            updateStickyPosition();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );

    // Recalculate initial position on resize
    window.addEventListener('resize', function () {
      // Remove fixed state temporarily to get accurate position
      const wasFixed = isFixed;
      if (wasFixed) {
        tabsContainer.classList.remove('is-fixed');
        if (placeholderElement && placeholderElement.parentNode) {
          placeholderElement.parentNode.removeChild(placeholderElement);
          placeholderElement = null;
        }
        isFixed = false;
      }

      initialTop = tabsContainer.getBoundingClientRect().top + window.scrollY;
      updateStickyPosition();
    });

    const publishedSectionId = tabsContainer.dataset.publishedSectionId || '';
    const recommendedSectionId = tabsContainer.dataset.recommendedSectionId || '';

    function findTargetSection(sectionId) {
      if (!sectionId) return null;

      // Normalize section ID - Shopify wraps sections with shopify-section- prefix
      let normalizedId = sectionId.trim();
      if (!normalizedId.startsWith('shopify-section-')) {
        normalizedId = `shopify-section-${normalizedId}`;
      }

      // Try to find by normalized ID first (Shopify wrapper div)
      let targetSection = document.getElementById(normalizedId);
      if (targetSection) return targetSection;

      // Try original ID if different
      if (sectionId !== normalizedId) {
        targetSection = document.getElementById(sectionId);
        if (targetSection) return targetSection;
      }

      // Try finding by attribute selector
      targetSection = document.querySelector(`[id="${normalizedId}"]`);
      if (targetSection) return targetSection;

      // Try finding by attribute selector with original ID
      if (sectionId !== normalizedId) {
        targetSection = document.querySelector(`[id="${sectionId}"]`);
        if (targetSection) return targetSection;
      }

      // If it's a load-more section, try to find by data-testid and check parent
      if (sectionId.includes('load') || sectionId.includes('product')) {
        const loadMoreSections = document.querySelectorAll('[data-testid="load-more-product-grid"]');
        for (const loadMoreSection of loadMoreSections) {
          const parentSection = loadMoreSection.closest('[id^="shopify-section-"]');
          if (
            parentSection &&
            (parentSection.id === normalizedId || parentSection.id.includes(sectionId.replace('shopify-section-', '')))
          ) {
            return parentSection;
          }
        }
      }

      return null;
    }

    function scrollToSection(targetSection) {
      if (!targetSection) return;

      // Calculate total offset: header height + tabs container height + extra spacing
      const tabsHeight = tabsContainer.offsetHeight || 57;
      const totalOffset = headerHeight + tabsHeight + 12;

      const elementPosition = targetSection.getBoundingClientRect().top;
      const currentScrollY = window.scrollY || window.pageYOffset;
      const offsetPosition = elementPosition + currentScrollY - totalOffset;

      window.scrollTo({
        top: Math.max(0, offsetPosition),
        behavior: 'smooth',
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        const tabName = this.dataset.tab;

        // Remove active class from all tabs
        tabs.forEach((t) => t.classList.remove('mobile-product-tabs__tab--active'));

        // Add active class to clicked tab
        this.classList.add('mobile-product-tabs__tab--active');

        // Handle Published tab
        if (tabName === 'published') {
          const targetSection = findTargetSection(publishedSectionId);
          scrollToSection(targetSection);
        }

        // Handle Recommended tab
        if (tabName === 'recommended') {
          const targetSection = findTargetSection(recommendedSectionId);
          scrollToSection(targetSection);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
